import type { DeckTranslations } from '../../i18n/types';
import ThreeColumn from './ThreeColumn';
import ToolCards from './ToolCards';
import FileTree from './FileTree';
import SkillsWorkflows from './SkillsWorkflows';
import IDETable from './IDETable';
import Swimlane from './Swimlane';
import PromptAnatomy from './PromptAnatomy';
import TestingFlows from './TestingFlows';
import ProblemSolution from './ProblemSolution';
import SecurityLayers from './SecurityLayers';
import IOMapTable from './IOMapTable';
import DarkHero from './DarkHero';

interface Props { stepIndex: number; deck: DeckTranslations }

export default function StepSlides({ stepIndex, deck }: Props) {
  switch (stepIndex) {
    case 0: return (
      <>
        <ThreeColumn
          title={deck.s1_title} sub={deck.s1_sub} msg={deck.s1_msg}
          col1_t={deck.s1_col1_t} col2_t={deck.s1_col2_t} col3_t={deck.s1_col3_t}
          col1={deck.s1_col1} col2={deck.s1_col2} col3={deck.s1_col3}
        />
        <ToolCards
          title={deck.s1b_title} sub={deck.s1b_sub}
          groups={deck.s1b_groups} flow={deck.s1b_flow} note={deck.s1b_note}
        />
      </>
    );
    case 1: return (
      <>
        <FileTree title={deck.s2_title} sub={deck.s2_sub} tree={deck.s2_tree} legend={deck.s2_legend} />
        <FileTree title={deck.s2b_title} sub={deck.s2b_sub} tree={deck.s2b_tree} />
        <SkillsWorkflows
          title={deck.s2c_title} sub={deck.s2c_sub}
          skills_t={deck.s2c_skills_t} workflows_t={deck.s2c_workflows_t}
          skills={deck.s2c_skills} workflows={deck.s2c_workflows}
        />
      </>
    );
    case 2: return (
      <IDETable title={deck.s3_title} sub={deck.s3_sub} th={deck.s3_th} rows={deck.s3_rows} />
    );
    case 3: return (
      <Swimlane title={deck.s4_title} sub={deck.s4_sub} lanes={deck.s4_lanes} steps={deck.s4_steps} />
    );
    case 4: return (
      <>
        <Swimlane title={deck.s5_title} sub={deck.s5_sub} lanes={deck.s5_lanes} steps={deck.s5_steps} />
        <PromptAnatomy
          title={deck.s5b_title} sub={deck.s5b_sub}
          anat_t={deck.s5b_anat_t} examples_t={deck.s5b_examples_t}
          anat={deck.s5b_anat} examples={deck.s5b_examples}
        />
        <Swimlane title={deck.s5c_title} sub={deck.s5c_sub} lanes={deck.s5c_lanes} steps={deck.s5c_steps} tips={deck.s5c_tips} />
        <Swimlane title={deck.s5d_title} sub={deck.s5d_sub} lanes={deck.s5d_lanes} steps={deck.s5d_steps} tips={deck.s5d_tips} />
        <Swimlane title={deck.s5e_title} sub={deck.s5e_sub} lanes={deck.s5e_lanes} steps={deck.s5e_steps} tips={deck.s5e_tips} />
        <Swimlane title={deck.s5f_title} sub={deck.s5f_sub} lanes={deck.s5f_lanes} steps={deck.s5f_steps} tips={deck.s5f_tips} />
        <Swimlane title={deck.s5g_title} sub={deck.s5g_sub} lanes={deck.s5g_lanes} steps={deck.s5g_steps} tips={deck.s5g_tips} />
        <Swimlane title={deck.s5h_title} sub={deck.s5h_sub} lanes={deck.s5h_lanes} steps={deck.s5h_steps} tips={deck.s5h_tips} />
      </>
    );
    case 5: return (
      <TestingFlows title={deck.s6_title} sub={deck.s6_sub} flows={deck.s6_flows} />
    );
    case 6: return (
      <ProblemSolution
        title={deck.s7_title} sub={deck.s7_sub}
        problem_t={deck.s7_problem_t} problem={deck.s7_problem}
        solution_t={deck.s7_solution_t} solution={deck.s7_solution}
      />
    );
    case 7: return (
      <SecurityLayers
        title={deck.s8_title} sub={deck.s8_sub}
        layers={deck.s8_layers} rules_t={deck.s8_rules_t} rules={deck.s8_rules}
      />
    );
    case 8: return (
      <IOMapTable title={deck.s9_title} sub={deck.s9_sub} th={deck.s9_th} rows={deck.s9_rows} />
    );
    case 9: return (
      <DarkHero
        title={deck.s10_title} sub={deck.s10_sub}
        not_t={deck.s10_not_t} not={deck.s10_not}
        triggers_t={deck.s10_triggers_t} triggers={deck.s10_triggers}
      />
    );
    default: return null;
  }
}
